import { config } from "@repo/config";
import { DeleteOrganizationForm } from "@saas/organizations/components/DeleteOrganizationForm";
import { OrganizationProfileSection } from "@saas/organizations/components/OrganizationProfileSection";
import { SettingsPageIntro } from "@saas/settings/components/SettingsLayout";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_saas/app/_org/$organizationSlug/settings/general",
)({
	head: () => ({
		meta: [{ title: `Retailer settings - ${config.appName}` }],
	}),
	component: OrganizationGeneralSettingsPage,
});

function OrganizationGeneralSettingsPage() {
	const { isOrganizationAdmin } = Route.useRouteContext();
	return (
		<>
			<SettingsPageIntro title="General" />
			<OrganizationProfileSection />
			{isOrganizationAdmin ? <DeleteOrganizationForm /> : null}
		</>
	);
}
